import { Component, OnInit, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomBlockAtributoComponent } from '../../helpers/components/customAttributeBlock/customBlockAttribute.component';
import {
  UsuariosService,
  VariableCircuitoIn,
  VariableCircuitoOut,
  APISXResultData,
  ResponseInvocacionUsuario,
  ResponseConfiguration,
} from '../../infrastructure/services/usuarios.service';
import {
  AlertService,
  GrowlType,
} from '../../infrastructure/services/alert.service';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { OpcionCheckeable } from 'app/infrastructure/services/selects.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';


@Component({
  selector: 'sx-vista-comando-usuario',
  templateUrl: 'vista.comando.component.html',
})
export class VistaComandoComponent implements OnInit {
  @ViewChildren('customBlocks') customBlocks: CustomBlockAtributoComponent[];
  categories: OpcionCheckeable[];
  selectedCategories: string[];
  codServicio = 'SrvUsuario';
  codSistema;
  codNegocio;
  codComando;
  userId;
  atributos;
  values = {};
  errores = {};
  mostrarRespuesta = false;
  respuestaInvocacion: ResponseInvocacionUsuario;
  respuestaListado: {
    headers: string[];
    filas: any;
  } = {
    headers: [],
    filas: [],
  };
  roles: Role[] = [];
  selectedRole: string;
  adminUserName: string;
  activeRoles: { [roleCode: string]: boolean } = {};

  constructor(
    private aRoute: ActivatedRoute,
    private router: Router,
    private usuariosService: UsuariosService,
    private alertService: AlertService, 
    private sxTranslationService: SxTranslationService
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      if (this.codSistema === undefined && this.codNegocio === undefined) {
        this.codSistema = 'null';
        this.codNegocio = 'null';
      }

      this.codComando = params['codcomando'];
      this.userId = params['id'];

      this.usuariosService
        .getFormulario(
          this.codSistema,
          this.codNegocio,
          this.codComando,
          this.userId
        )
        .then((response) => {
          this.usuariosService.getCategories().then((x) => {
            this.inicializarFormulario(response);
            this.categories = x.map(cat => {return {id: cat.categoryId, descripcion: cat.descripcion, seleccionado: cat.selected} as OpcionCheckeable});
            if (this.codComando === 'Edicion' && this.selectedCategories != null) 
              this.maperCategories();
          });
        });
    });
  }

  enviar() {
    let form: VariableCircuitoIn[] = Object.keys(this.values).map((key) => ({
      codigo: key,
      valor: this.values[key],
    }));

    if (!this.formularioValido(form)) {
      return;
    }

    // TODO: validar customb blocks
    this.customBlocks.forEach((block) => {
      const variables = block.getValues();
      form = [...form, ...variables];
    });

    let requestedRoles = [];
    if (this.roles) {
      requestedRoles = this.roles.filter((r) => this.activeRoles[r.roleCode]);
    }

    this.usuariosService
      .invocarComando(
        this.codSistema,
        this.codNegocio,
        this.codComando,
        form,
        requestedRoles
      )
      .then((res) => {
        // La invocacion del comando fallo
        if (res.errores.length > 0) {
          this.mostrarErrores(res.errores);
          return;
        }

        // Invocacion del comando exitosa
        this.respuestaInvocacion = res.result;

        this.alertService.showGrowl({
          body: this.respuestaInvocacion.msgResult,
          type: GrowlType.SUCCESS,
        });

        this.mostrarRespuesta = true;     
        // Si es listado, debemos hacer un tratamiento especial para obtener los
        // datos que vienen en la respuesta    
        if (this.codComando === 'Listado') {     
          this.parsearRespuestaListado(this.respuestaInvocacion.infoUsuario);
        }     
        //Si es de usuarios de soc
        else if (this.codNegocio == 'null' && this.codSistema == 'null') {
          this.router.navigate([`soc/users/service/UsersAdmin`]);
        } 
        //Si es de usuarios de un canal/negocio
        else {
          this.router.navigate(['../../'], { relativeTo: this.aRoute });
        }
      });
  }

  /**
   * Crea la estructura que se usara para llenar la tabla con
   * el listado de usuarios a partir de la respuesta que proviene
   * de la llamada a la invocacion del comando Listado
   *
   * @param listado
   */
  parsearRespuestaListado(listado: VariableCircuitoIn[]) {
    // Si no hay usuarios, no hay nada que hacer
    if (listado.length <= 0) {
      return;
    }

    // Parseamos cada usuario
    const listadoParseado = listado.map((variableIn) => {
      const variableParseada = JSON.parse(variableIn.valor);
      const valorParseado = JSON.parse(variableParseada.Valor);
      return valorParseado;
    });

    // Buscamos el usuario que tenga la mayor cantidad de campos
    // para armar el header de la tabla con sus campos
    let maxCampos = 0;
    let usuarioConMasCampos = listadoParseado[0];
    listadoParseado.forEach((campos) => {
      if (campos.length > maxCampos) {
        maxCampos = campos.length;
        usuarioConMasCampos = campos;
      }
    });

    // Nos quedamos solo con el codigo
    this.respuestaListado.headers = usuarioConMasCampos.map(
      (valor) => valor.Codigo
    );

    // Cada usuario es convertido en una fila, y cada atributo en una columna
    listadoParseado.forEach((value) => {
      const fila = [];
      value.forEach((val) => {
        fila[val.Codigo] = val.Valor;
      });
      this.respuestaListado.filas.push(fila);
    });
  }

  inicializarFormulario(response: ResponseConfiguration) {
    this.atributos = response.form;
    this.roles = response.roles;
    this.adminUserName = response.adminUser;
    this.atributos.forEach((atributo) => {
      if (atributo.tipo !== 'Custom') {
        this.values[atributo.codigo] = atributo.valorDefault;
      }
      if (atributo.codigo === 'USR_CATEGORYVISIBILITY' && atributo.valorDefault != null) {
        this.selectedCategories = atributo.valorDefault.split('|');
      }
     /** */if (atributo.codigo === 'PARAM_ADIC_COD_AGENT') {
        atributo.titulo=this.sxTranslationService.getResource('PARAM_ADIC_COD_AGENT');
      } 
      if (atributo.tipo === 'DateTime') {
        this.values[atributo.codigo] = atributo.valorDefault;
      }
      
      if (atributo.tipo === 'TABLA_SIMPLE') {
        atributo.extraInfo = JSON.parse(atributo.extraInfo);
      }
    });
    
  }

  /**
   * Retorna el titutlo del atributo concatenado con (*)
   * en caso de que este sea obligatorio
   */
  getLabel(atributo: VariableCircuitoOut) {
    let label = atributo.titulo;
    if (!atributo.esOpcional) {
      label += ' (*)';
    }
    return label;
  }

  /**
   * Valida cada campo del formulario, checkeando los que
   * son obligatorios. Retorna true solo si cada campo
   * obligatorio fue ingresado.
   */
  formularioValido(form: VariableCircuitoIn[]): boolean {
    this.errores = {};
    if (this.atributos.length > 0) {
      return this.atributos
        .map(this.campoValido.bind(this, form))
        .reduce((current, total) => current && total);
    } else {
      return true;
    }
  }

  /**
   * Valida que el atributo pasado sea valido.
   */
  campoValido(
    form: VariableCircuitoIn[],
    atributo: VariableCircuitoOut
  ): boolean {
    let esValido = true;
    const variable = form.find((atr) => atr.codigo === atributo.codigo);

    if (!variable) {
      return true;
    }

    const valor = variable.valor;

    if (!atributo.esOpcional) {
      esValido = !!valor;
      if (!esValido) {
        this.errores[atributo.codigo] = 'VALOR_REQUERIDO';
      }
    }

    return esValido;
  }

  /**
   * Formatea un date obtenido de un input html
   * a un formato compatible con Datetime del backend
   * y lo almacena en el la lista de values
   *
   * @param value Valor proveniendo del input date (YYYY-MM-DD)
   * @param codigoAtributo Key para saber que campo se esta actualizando
   */
  formatDate(value, codigoAtributo) {
    const splitedDate = value.split('-');
    this.values[codigoAtributo] = value; // splitedDate.reverse().join('/');
  }

  mostrarErrores(errores) {
    errores.forEach((error) => {
      this.alertService.showGrowl({
        body: error.errorMessage,
        type: GrowlType.DANGER,
      });
    });
  }

  seleccionarOpcion(codigo, opcion) {
    console.log(codigo, opcion);
    this.values[codigo] = opcion.value;
  }

  editUser(userId) {
    this.router.navigate(['../Edicion', userId], { relativeTo: this.aRoute });
  }

  showRoles(): boolean {
    return this.codComando === 'Alta';
  }

  addRole() {
    this.activeRoles[this.selectedRole] = true;
  }

  removeRole(roleCode: string) {
    this.activeRoles[roleCode] = false;
  }
  changeCategories(categories: OpcionCheckeable[]) {
    this.selectedCategories = [];
    if (categories) {
      categories.forEach((category) =>
        this.selectedCategories.push(category.descripcion)
      );
      this.values['USR_CATEGORYVISIBILITY'] = this.selectedCategories.join('|');
    }
  }

  maperCategories() {
    this.categories.forEach(
      (category) =>
        (category.seleccionado = this.selectedCategories.some(
          (x) => x === category.descripcion
        ))
    );
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/usuarios/vista.comando.component.ts